var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 267.409,
    height: 267.409,
    viewBox: "0 0 267.409 267.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8f2ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_2",
    x: 0,
    y: 0,
    width: 267.409,
    height: 267.409,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b5beff",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-826.296 -316.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M879.6,442.755s-51.451,132.03,137.364-22.682",
    transform: "translate(4 -1)",
    fill: "none",
    stroke: "#fdbf00",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 826.3, 316.3)",
    filter: "url(#Ellipse_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    cx: 81,
    cy: 81,
    r: 81,
    transform: "matrix(0.26, 0.97, -0.97, 0.26, 190.98, 22.5)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 68,
    cy: 68,
    r: 68,
    transform: "translate(892 370)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-up",
    transform: "translate(928.339 410.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M60.8,29.141a4.747,4.747,0,0,1-1.384,3.367l-2.806,2.806a4.644,4.644,0,0,1-3.4,1.422,4.446,4.446,0,0,1-3.367-1.422l-11-10.961V50.688a3.986,3.986,0,0,1-1.4,3.161,4.993,4.993,0,0,1-3.385,1.216H29.267a4.993,4.993,0,0,1-3.385-1.216,3.986,3.986,0,0,1-1.4-3.161V24.353l-11,10.961a4.445,4.445,0,0,1-3.367,1.422,4.445,4.445,0,0,1-3.367-1.422L3.942,32.508a4.742,4.742,0,0,1,0-6.771L28.294,1.384A4.428,4.428,0,0,1,31.661,0a4.627,4.627,0,0,1,3.4,1.384L59.418,25.737A4.791,4.791,0,0,1,60.8,29.141Z",
    fill: "#2d66e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 1015.02, 383.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M12.168,358.966a.5.5,0,0,1-.5-.4l-.781-3.357-7.442,3.66a.517.517,0,0,1-.694-.694L6.4,350.718l-3.357-.781a.52.52,0,0,1-.1-.98l9.211-4.224a.531.531,0,0,1,.7.7c1.355.8,4.258,3.533,4.037,4.035l-4.25,9.194a.538.538,0,0,1-.477.3Z",
    transform: "translate(-2.392 -314.784)",
    fill: "#fdbf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M10.566,145.534h-.017L.522,145.152a.521.521,0,0,1-.321-.911L11.91,133.833a.5.5,0,0,1,.243-.121l5.889-1.223c.553-.118-5.255,8.941-7.579,12.007.962.037.706,1.038.1,1.038Z",
    transform: "translate(0 -120.997)",
    fill: "#ff193d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M229.976,315.892a.535.535,0,0,1-.52-.5l-.382-10.027c-.021-.62,10.2-7.095,12.037-7.714a.522.522,0,0,1,1.016.237l-1.223,5.889a.537.537,0,0,1-.121.243l-10.417,11.7a.527.527,0,0,1-.39.173Z",
    transform: "translate(-209.184 -271.483)",
    fill: "#ff193d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M125.756,34.39a.485.485,0,0,1-.364-.156l-9.836-9.827a.528.528,0,0,1-.121-.555A37.178,37.178,0,0,1,149.27,0a.529.529,0,0,1,.529.529A36.791,36.791,0,0,1,138.94,25.907a37.068,37.068,0,0,1-13,8.457.618.618,0,0,1-.182.026Z",
    transform: "translate(-105.371)",
    fill: "#e1f1fa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M367.694,2.238A35.143,35.143,0,0,1,379.655,0a.529.529,0,0,1,.529.529,35.189,35.189,0,0,1-2.238,11.95l-.271.029a10.581,10.581,0,0,1-10.006-10,.963.963,0,0,1,.026-.272Z",
    transform: "translate(-335.756 0)",
    fill: "#f6fbfb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M382.28,12.073h-.026a10.08,10.08,0,0,1-6.627-2.958,10.163,10.163,0,0,1-2.958-6.627.527.527,0,0,1,.347-.52A37.05,37.05,0,0,1,384.231,0a.529.529,0,0,1,.52.529,36.34,36.34,0,0,1-1.978,11.2.516.516,0,0,1-.494.347Z",
    transform: "translate(-340.324 0)",
    fill: "#ff193d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(5.529 11.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M75.9,286.518a.485.485,0,0,1-.364-.156L63.662,274.5a.517.517,0,0,1,.121-.824l4.5-2.463a.513.513,0,0,1,.616.087l9.827,9.827a.513.513,0,0,1,.087.616l-2.463,4.5a.531.531,0,0,1-.451.277Z",
    transform: "translate(-63.509 -258.671)",
    fill: "#313e5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M275.71,137.216a4.935,4.935,0,1,1,3.5-8.422,4.939,4.939,0,0,1-3.5,8.422Z",
    transform: "translate(-252.798 -127.35)",
    fill: "#313e5b",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1016.96,420.073c-64.008,52.447-88.665,65.967-109.969,72.513C866.3,505.093,873.8,466.868,873.8,466.868",
    transform: "translate(4 -1)",
    fill: "none",
    stroke: "#fdbf00",
    strokeLinecap: "round",
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubExpired);
export default __webpack_public_path__ + "static/media/sub-expired.aa4660b25d88073f506fe624c4a68739.svg";
export { ForwardRef as ReactComponent };